package ir.site.zero1plus.components.sections

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.dom.ref
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.attrsModifier
import com.varabyte.kobweb.compose.ui.modifiers.attrs
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.core.isExporting
import ir.site.zero1plus.components.widgets.SectionHeading
import ir.site.zero1plus.model.NavBarMenu
import kotlinx.browser.document
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.A
import org.jetbrains.compose.web.dom.H2
import org.jetbrains.compose.web.dom.Img
import org.jetbrains.compose.web.dom.Text
import org.w3c.dom.HTMLScriptElement

@Composable
fun LicenseSection() {
    Box(
        modifier = Modifier
            .id(NavBarMenu.License.id)
            .fillMaxWidth()
            .padding(topBottom = 100.px),
        contentAlignment = Alignment.Center
    ) {
        Column(
            modifier = Modifier.fillMaxWidth(80.percent),
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.spacedBy(60.px)
        ) {

            SectionHeading(
                title = "مجوز ها"
            )

            if (!AppGlobals.isExporting) {
                Row(
                    modifier = Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.SpaceAround,
                    verticalAlignment = Alignment.CenterVertically,
                    ref = ref {
                        val zerinpalLogoScript = document.createElement("script") as HTMLScriptElement
                        zerinpalLogoScript.src = "https://www.zarinpal.com/webservice/TrustCode"
                        zerinpalLogoScript.type = "text/javascript"
                        it.appendChild(zerinpalLogoScript)
                    }
                ) {
                    //zerinpal
                    A(
                        href = "javascript:showZPTrust();",
                        attrs = Modifier.toAttrs {
                            title("دروازه پرداخت معتبر")
                        }
                    ){
                        Img(
                            src = "https://cdn.zarinpal.com/badges/trustLogo/1.png",
                            alt = "دروازه پرداخت معتبر",
                            attrs = Modifier.toAttrs {
                                attr("border" , "0")
                            }
                        )
                    }
                    //zerinpal


                    //enamad
                    A(
                        href = "https://trustseal.enamad.ir/?id=463107&Code=vpr9VPeRhqqPdM1xAZWYJUu2dnBVdZMT",
                        attrs = Modifier
                            .attrsModifier {
                                attr("referrerpolicy", "origin")
                                attr("target", "_blank")
                            }.toAttrs()
                    ) {
                        Img(
                            attrs = Modifier
                                .attrsModifier {
                                    attr("referrerpolicy", "origin")
                                    attr("Code", "vpr9VPeRhqqPdM1xAZWYJUu2dnBVdZMT")
                                }.toAttrs(),
                            src = "https://trustseal.enamad.ir/logo.aspx?id=463107&Code=vpr9VPeRhqqPdM1xAZWYJUu2dnBVdZMT",
                            alt = "load error"
                        )
                    }
                    //enamad
                }
            }
        }
    }
}